import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import StickyCall from "../components/StickyCall";
import { Phone, Leaf, CheckCircle2 } from "lucide-react";
import { site } from "../mock";
import { CallbackButton } from "../components/PageBlocks";

export default function Guerisseur() {
  return (
    <div>
      <Header />
      <StickyCall />
      <section className="hero-radial py-14 md:py-20">
        <div className="container-narrow grid md:grid-cols-2 gap-8 md:gap-10 items-center">
          <div className="order-1 md:order-none">
            <p className="text-[11px] uppercase tracking-[0.3em] text-gold-deep mb-3">Guérisseur africain</p>
            <h1 className="font-display text-4xl md:text-5xl gold-gradient-text mb-4">Retrouver la paix du corps et de l'esprit</h1>
            <div className="gold-divider my-5 max-w-[220px]" />
            <p className="text-gold-soft/95 leading-relaxed mb-4">
              Certaines souffrances résistent aux traitements ordinaires : douleurs sans explication, angoisses persistantes, sommeil brisé, impression d'être «bloqué». Ces signes révèlent souvent un <span className="text-gold">désordre spirituel</span> qui précède l'atteinte physique.
            </p>
            <p className="text-gold-soft/95 leading-relaxed mb-6">
              Par ses soins traditionnels africains, Maître Diamma libère les énergies bloquées, purifie ce qui doit l'être et rétablit l'harmonie entre vous et les forces invisibles. Ses consultants retrouvent énergie, sérénité et confiance.
            </p>
            <div className="flex flex-wrap gap-3">
              <CallbackButton id="guerisseur-hero" context="Guérisseur" />
              <a href={`tel:${site.phoneRaw}`} className="btn-gold inline-flex rounded-md px-6 py-3 items-center gap-2">
                <Phone className="w-4 h-4" /> Demander un soin
              </a>
            </div>
          </div>
          <div className="relative rounded-xl overflow-hidden gold-border-strong order-2 md:order-none">
            <img src="/images/diamma-ecriture.jpg" alt="Maître Diamma, guérisseur africain à Orléans" className="w-full h-[300px] md:h-[440px] object-cover object-top" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent" />
          </div>
        </div>
      </section>
      <section className="py-14 md:py-16 bg-charcoal">
        <div className="container-narrow max-w-4xl">
          <div className="card-onyx rounded-xl p-8">
            <Leaf className="w-8 h-8 text-gold mb-3" />
            <h3 className="font-display text-2xl text-gold mb-3">Ce que Maître Diamma traite en profondeur</h3>
            <ul className="grid sm:grid-cols-2 gap-3 mt-4">
              {["Désenvoûtement complet et durable", "Libération des mauvais sorts et jalousies", "Purification du foyer et du lieu de vie", "Retour d'un sommeil profond et réparateur", "Douleurs et malaises inexpliqués", "Angoisses, peurs et blocages mentaux", "Retrouver puissance et vitalité intime", "Protection spéciale famille & enfants"].map((v) => (
                <li key={v} className="flex items-start gap-2 text-sm text-gold-soft/95"><CheckCircle2 className="w-4 h-4 text-gold mt-0.5" /> {v}</li>
              ))}
            </ul>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}
